import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import {
  CustomSelectField,
  CustomTextField,
} from "../../../../../partials/content/Forms";
import {
  onPreventEnterSubmitting,
  setObject,
} from "../../../../../utils/utils";
import { DialogActions } from "@material-ui/core";
import { saveCustomerAddress } from "../../../../../services/sales/customerService";
import Swal from "sweetalert2";
import { Card } from "react-bootstrap";
import { getCountries } from "../../../../../services/setup/customer/customerSetupService";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import store from "../../../../../store/store";
import { DateTime } from "luxon";
import {
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import MapPlaces from "../../../../../partials/content/MapPlaces";
import DialogLayout from "../../../../../partials/content/DialogLayout";
const CustomerAddressForm = ({
  customerID,
  address,
  action,
  onCloseDialog,
  onConfirmSave,
}) => {
  const { socket, companyProfile } = useGlobalData();
  const [openSearchMapPlaces, setOpenSearchMapPlaces] = useState(false);
  let addressData = {
    ID: 0,
    customerID: customerID,
    addressName: "",
    address: "",
    city: "",
    province: "",
    countryCode: companyProfile.countryCode,
    countryName: "",
    postalCode: "",
    addressPhone: "",
    addressEmail: "",
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  };
  if (address && address.ID > 0) {
    addressData = {
      ID: address.ID,
      customerID: customerID,
      addressName: address.addressName,
      address: address.address,
      city: address.city,
      province: address.province,
      countryCode: address.countryCode,
      countryName: address.countryName,
      postalCode: address.postalCode,
      addressPhone: address.addressPhone,
      addressEmail: address.addressEmail,
      CreatedAt: address.CreatedAt,
      UpdatedAt: address.UpdatedAt,
      createdBy: address.createdBy,
      updatedBy: address.updatedBy,
    };
  }

  const addressFormSchema = yup.object().shape({
    customerID: yup.number(),
    addressName: yup
      .string()
      .required("Address Name is required")
      .max(255, "Address Name maximum characters is 255"),
    address: yup
      .string()
      .required("Address is required")
      .max(255, "Address maximum characters is 255"),
    city: yup
      .string()
      .required("City is required")
      .max(50, "City maximum characters is 50"),
    province: yup.string().max(50, "Province maximum characters is 50"),
    countryCode: yup.string(),
    postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
    addressPhone: yup
      .string()
      .required("Phone Number is required")
      .matches(
        /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
        "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
      )
      .max(50, "Phone Number maximum characters is 50"),
    addressEmail: yup
      .string()
      .email("Email must be valid. e.g. joe@invifo.com")
      .required("Email is required")
      .max(50, "Email maximum characters is 50"),
  });

  const [countryOptions, setCountryOptions] = useState([]);
  useEffect(() => {
    const { auth } = store.getState();

    getCountriesData();

    if (address && address.ID > 0) {
      setObject(socket, "lock", address.ID, "CUAD", auth.user)
        .then((response) => {})
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (address && address.ID > 0) {
        setObject(socket, "release", address.ID, "CUAD", auth.user);
      }
    };
  }, []);

  return (
    <Formik
      initialValues={addressData}
      validationSchema={addressFormSchema}
      enableReinitialize={true}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        values.customerID = parseFloat(values.customerID);
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Customer Address ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveCustomerAddress(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Card>
                <Card.Header>
                  <i className="fas fa-th-large"></i>
                  <span>
                    <strong>Customer Address Basic Info</strong>
                  </span>
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField label="Address Name" name="addressName" />
                      <FormTextField label="Phone Number" name="addressPhone" />
                      <FormTextField label="Email" name="addressEmail" />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Address"
                        name="address"
                        mapsButton
                        onMapsClick={() => {
                          setOpenSearchMapPlaces(true);
                          console.log("val", values);
                        }}
                      />
                      <FormTextField label="City" name="city" />
                      <FormTextField label="Province / State" name="province" />
                      <FormSelectField
                        label="Country"
                        name="countryCode"
                        options={countryOptions}
                      />
                      <FormTextField label="Postal Code" name="postalCode" />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>

            {action === "create" || action === "edit" ? (
              <button
                type="submit"
                className="btn btn-success btn-md btn-pill btn-bold"
                disabled={isSubmitting}
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            ) : null}
          </DialogActions>
          <DialogLayout
            open={openSearchMapPlaces}
            title="Search Address on Maps"
            onCloseDialog={() => {
              setOpenSearchMapPlaces(false);
            }}
            maxWIdth="lg"
            minHeight={true}
          >
            <MapPlaces
              address={values.address}
              city={values.city}
              province={values.province}
              countryCode={values.countryCode}
              postalCode={values.postalCode}
              onPinLocation={(
                selectedFormattedAddress,
                selectedShortAddressComponents,
                selectedLongAddressComponents,
                selectedAddress,
                selectedCity,
                selectedProvince,
                selectedCountryCode,
                selectedPostalCode
              ) => {
                console.log("selectedAddress", selectedAddress);
                setFieldValue(`address`, selectedAddress);
                setFieldValue(`city`, selectedCity);
                setFieldValue(`province`, selectedProvince);
                setFieldValue(`countryCode`, selectedCountryCode);
                setFieldValue(`postalCode`, selectedPostalCode);
                setOpenSearchMapPlaces(false);
              }}
              onCloseDialog={() => {
                setOpenSearchMapPlaces(false);
              }}
            />
          </DialogLayout>
        </form>
      )}
    </Formik>
  );

  async function getCountriesData() {
    let countryOptionsTmp = [];
    const response = await getCountries();
    const { data } = response.data;

    data.countries.forEach((country) => {
      countryOptionsTmp.push({
        value: country.countryCode,
        label: country.countryName,
      });
    });

    setCountryOptions(countryOptionsTmp);
  }
};

export default CustomerAddressForm;
